import React, {useState} from 'react';
import PropTypes from 'prop-types';

const colorClassMap = {
    success: 'alert-success',
    error: 'alert-error',
    warning: 'alert-warning',
    notice: 'alert-notice'
};

const iconClassMap = {
    success: 'icon-ok-circled',
    error: 'icon-attention-circled',
    warning: 'icon-attention',
    notice: 'icon-info-circled'
};

const Alert = (props)=>{
    const {
        children,
        className,
        color,
        dismissable,
        onClose,
        autoIcon,
        ...otherProps
    } = props;

    const [open, setOpen] = useState(true);

    if(!open) {
        // TODO: fade out instead of hiding immediately
        return '';
    }

    let classes = ['alert', colorClassMap[color], className];

    let closeIcon = '';
    if(dismissable) {
        const handleClose = ()=>{
            setOpen(false);
            if(props.onClose) props.onClose();
        };
        closeIcon = (
            <i className="icon-cancel-light" onClick={handleClose}/>
        );
    }

    let icon = '';
    if(autoIcon) {
        icon = (
            <i className={iconClassMap[color]}/>
        );
    }

    return (
        <div className={classes.join(' ')} {...otherProps}>
            {icon}
            {children}
            {closeIcon}
        </div>
    );
};
Alert.displayName = 'Alert';
Alert.propTypes = {
    autoIcon: PropTypes.bool,
    color: PropTypes.oneOf(Object.keys(colorClassMap)).isRequired,
    dismissable: PropTypes.bool,
    /** Only fired when dismissable is true and the user clicks the close icon */
    onClose: PropTypes.func
};
Alert.defaultProps = {
    autoIcon: true,
    color: 'notice',
    dismissable: false
};

export default Alert;